import HaveIBeenPwned from 'services/hibp.service';
import ERRORS from 'constants/errors';

// Enforces NIST guidelines / Veracode recommendations
export const checkPasswordStrength = (password, email) => {
  let error = null;
  let score = 4;
  let hibpPromise = null;

  // Require mix of letters and numbers
  if (!password.match(/\d/) || !password.match(/\w/)) {
    score -= 1;
    error = ERRORS.passwordAlphanumeric;
  }

  // Require a mix of upper and lowercase characters
  const lowercasePassword = password.toLowerCase();
  if (password === lowercasePassword) {
    score -= 1;
    error = ERRORS.passwordCasemix;
  }

  // Forbid allowing 3 or more identical chars in sequence
  if (password.match(/^.*?(\S)\1\1.*?$/)) {
    score -= 1;
    error = ERRORS.passwordRepeatedCharacters;
  }

  // Forbid allowing 3 or more consecutive chars in sequence
  if (
    password.match(
      /(abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|012|123|234|345|456|567|678|789)+/gi
    )
  ) {
    score -= 1;
    error = ERRORS.passwordConsecutiveCharacters;
  }

  // Forbid password containing the email
  if (email && email !== '' && email.includes('@')) {
    const emailUser = email.split('@')[0];
    if (password.includes(emailUser)) {
      error = ERRORS.passwordContainsEmail;
      score -= 1;
    }
  }

  // Forbid the password containing 'NBX'
  if (password.includes('NBX')) {
    error = ERRORS.passwordContainsNBX;
    score -= 1;
  }

  // Minimum of 8 Characters
  if (password.length < 8) {
    score = 1;
    error = ERRORS.passwordLength;
  }

  // If no other errors, check against HIBP
  if (score === 4) {
    hibpPromise = HaveIBeenPwned.isPasswordPwned(password).then(pwned => {
      if (pwned) {
        return true;
      }
      return false;
    });
  }

  if (score < 1) score = 1;

  return { error, score, hibpPromise };
};
